<template>
  <v-row
    no-gutters
    justify="center"
    align="center"
    class="recurrent-intervention-recurrence px-4 py-2"
  >
    <v-icon class="mr-1">repeat</v-icon>
    <div class="font-weight-medium">Tous les</div>
    <div class="pl-2" style="width: 75px;">
      <v-select
        v-model="recurrenceInc"
        :items="recurrenceIncs"
        outlined
        dense
        hide-details
      />
    </div>
    <div class="pl-2" style="width: 150px;">
      <v-select
        v-model="recurrenceType"
        :items="recurrenceTypes"
        item-text="label"
        item-value="id"
        outlined
        dense
        hide-details
      />
    </div>
    <v-spacer />
    <template v-if="showNextAt">
      <v-icon class="mr-1">skip_next</v-icon>
      <div class="font-weight-medium">Prochaine éxécution le</div>
      <div class="pl-2" style="width: 140px;">
        <v-menu
          ref="menu"
          v-model="nextAtMenu"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="nextAtFormated"
              aappend-icon="event"
              outlined
              readonly
              hide-details
              dense
              v-bind="attrs"
              v-on="on"
            />
          </template>
          <v-date-picker
            v-model="nextAt"
            :first-day-of-week="1"
            :allowed-dates="isAllowedDate"
          ></v-date-picker>
        </v-menu>
      </div>
    </template>
    <template v-else>
      <v-icon class="mr-1">play_arrow</v-icon>
      <div class="font-weight-medium">À partir du</div>
      <div class="pl-2" style="width: 140px;">
        <v-menu
          ref="menu"
          v-model="startingAtMenu"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="startingAtFormated"
              aappend-icon="event"
              outlined
              readonly
              hide-details
              dense
              v-bind="attrs"
              v-on="on"
            />
          </template>
          <v-date-picker
            v-model="startingAt"
            :first-day-of-week="1"
            :allowed-dates="isAllowedDate"
          ></v-date-picker>
        </v-menu>
      </div>
    </template>
  </v-row>
</template>

<script>
import moment from 'moment';
import { mapActions, mapState } from 'vuex';

export default {
  props: {
    showNextAt: {
      type: Boolean,
      default: () => false,
    },
  },

  data: () => ({
    recurrenceIncs: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
    recurrenceTypes: [
      { id: `day`, label: `jours` },
      { id: `week`, label: `semaines` },
      { id: `month`, label: `mois` },
      { id: `year`, label: `ans` },
    ],
    startingAtMenu: false,
    nextAtMenu: false,
    startingAtFormated: null,
    nextAtFormated: null,
    todayMoment: moment().startOf(`day`),
  }),

  computed: {
    ...mapState(`ui/recurrentInterventionForm`, {
      storeRecurrentIntervention: `recurrentIntervention`,
    }),
    recurrentIntervention: {
      get() { return this.storeRecurrentIntervention; },
      set(recurrentIntervention) { this.setRecurrentIntervention(recurrentIntervention); },
    },
    recurrenceInc: {
      get() { return this.recurrentIntervention.recurrenceInc; },
      set(recurrenceInc) {
        this.recurrentIntervention = {
          ...this.recurrentIntervention,
          recurrenceInc,
        };
      },
    },
    recurrenceType: {
      get() { return this.recurrentIntervention.recurrenceType; },
      set(recurrenceType) {
        this.recurrentIntervention = {
          ...this.recurrentIntervention,
          recurrenceType,
        };
      },
    },
    startingAt: {
      get() {
        const { startingAt } = this.recurrentIntervention;
        if (startingAt) {
          return moment(startingAt, `YYYYMMDD`).format(`YYYY-MM-DD`);
        }

        return null;
      },
      set(value) {
        let startingAt = value;
        if (startingAt) {
          startingAt = moment(startingAt, `YYYY-MM-DD`);
          this.startingAtFormated = startingAt.format(`DD/MM/YYYY`);
        }
        this.recurrentIntervention = {
          ...this.recurrentIntervention,
          startingAt: startingAt ? startingAt.format(`YYYYMMDD`) : null,
        };
      },
    },
    nextAt: {
      get() {
        const { nextAt } = this.recurrentIntervention;
        if (nextAt) {
          return moment(nextAt, `YYYYMMDD`).format(`YYYY-MM-DD`);
        }

        return null;
      },
      set(value) {
        let nextAt = value;
        if (nextAt) {
          nextAt = moment(nextAt, `YYYY-MM-DD`);
          this.nextAtFormated = nextAt.format(`DD/MM/YYYY`);
        }
        this.recurrentIntervention = {
          ...this.recurrentIntervention,
          nextAt: nextAt ? nextAt.format(`YYYYMMDD`) : null,
        };
      },
    },
  },

  methods: {
    ...mapActions(`ui/recurrentInterventionForm`, [
      `setRecurrentIntervention`,
    ]),
    initRecurrentIntervention() {
      this.recurrenceInc = this.recurrentIntervention.recurrenceInc || this.recurrenceIncs[0];
      this.recurrenceType = this.recurrentIntervention.recurrenceType || `month`;
      let { startingAt, nextAt } = this.recurrentIntervention;
      if (!startingAt) {
        startingAt = moment();
      } else {
        startingAt = moment(startingAt, `YYYYMMDD`);
      }
      if (!nextAt) {
        nextAt = startingAt;
      } else {
        nextAt = moment(nextAt, `YYYYMMDD`);
      }
      this.startingAt = startingAt.format(`YYYY-MM-DD`);
      this.nextAt = nextAt.format(`YYYY-MM-DD`);
    },
    isAllowedDate(date) {
      return moment(date).isSameOrAfter(this.todayMoment);
    },
  },

  mounted() {
    this.initRecurrentIntervention();
  },

  watch: {
    startingAt(startingAt) {
      this.startingAtFormated = moment(startingAt, `YYYY-MM-DD`).format(`DD/MM/YYYY`);
    },
    nextAt(nextAt) {
      this.nextAtFormated = moment(nextAt, `YYYY-MM-DD`).format(`DD/MM/YYYY`);
    },
  },
};
</script>

<style lang="scss" scoped>
.recurrent-intervention-recurrence {
  background-color: #e7e8ff;
}
</style>
